import { CargoTemperatureConfig, InhibitorEffectivenessEntry } from '../../../types/ViewModel/CargoTempLog/CargoTemperatureConfig';

// Generic helpers
export const isNullOrEmpty = (v: unknown): boolean => v === null || v === undefined || v === '';

export const toNumberOrUndefined = (v: unknown): number | undefined => (v === '' || v === null || v === undefined ? undefined : Number(v));

// Domain validation helpers
export const hasValidEffectivenessEntry = (cfg: CargoTemperatureConfig): boolean => {
    if (!cfg.inhibitorEffectivenessEntries || cfg.inhibitorEffectivenessEntries.length === 0) return false;
    return (cfg.inhibitorEffectivenessEntries as InhibitorEffectivenessEntry[]).some(
        (e) => toNumberOrUndefined(e.days) && Number(e.days) > 0 && !isNullOrEmpty(e.temperature)
    );
};

export const getMissingFields = (cfg: CargoTemperatureConfig): string[] => {
    const missing: string[] = [];
    if (isNullOrEmpty(cfg.inhibitorType) || cfg.inhibitorType === 'Select an inhibitor type') missing.push('Name of additive (inhibitor)');
    if (!toNumberOrUndefined(cfg.inhibitorAmount)) missing.push('Amount of additive');
    if (isNullOrEmpty(cfg.inhibitorAddedDate)) missing.push('Date the additive was put in the product');
    if (!hasValidEffectivenessEntry(cfg)) missing.push('Inhibitor effectiveness (at least one entry with days > 0 and temperature)');
    if (cfg.isOxygenDependent && (!toNumberOrUndefined(cfg.minimumOxygenLevel) || Number(cfg.minimumOxygenLevel) <= 0))
        missing.push('Minimum level of Oxygen required');
    if (isNullOrEmpty(cfg.inhibitorExpiryAction)) missing.push('Action to be taken if voyage exceeds the effective lifetime');
    return missing;
};

export const isConfigValid = (cfg: CargoTemperatureConfig): boolean => getMissingFields(cfg).length === 0;

export default {
    isNullOrEmpty,
    toNumberOrUndefined,
    hasValidEffectivenessEntry,
    getMissingFields,
    isConfigValid,
};
